import { render } from "./ModalColorsSelector.vue?vue&type=template&id=4979450a&scoped=true"
import script from "./ModalColorsSelector.vue?vue&type=script&lang=js"
export * from "./ModalColorsSelector.vue?vue&type=script&lang=js"

import "./ModalColorsSelector.vue?vue&type=style&index=0&id=4979450a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4979450a"]])

export default __exports__